/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setScrollBar.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";

//gsapのプラグインを登録
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

/**
 * scrollBar
 */
function setScrollBar() {
    let actionOption = { duration: 0.5, ease: "power4.out", overwrite: true, }
    let html, bar, track, vh, maxScroll, bar_H, scroll, scrollRatio, barPos, rect, offsetY;
    let timeoutId;
    let setTime = 1000;

    //初期設定
    const init = () => {
        html = document.querySelector("html"); //html
        bar = document.querySelector(".--bar"); //スクロールバー
        track = document.querySelector(".--track"); //トラック
        vh = window.innerHeight; //画面の高さ
        maxScroll = document.body.scrollHeight - vh; //スクロールの最大値
        bar_H = vh / (document.body.scrollHeight / vh) / 1.2; //スクロールバーの高さ
        gsap.set(bar, { height: bar_H, opacity: 0, }); //スクロールバーの高さを設定
    }

    //スクロール時の共通処理
    const scrollProcess = () => {
        scroll = window.pageYOffset;
        scrollRatio = scroll / maxScroll;
        barPos = scrollRatio * (vh - bar_H);
        gsap.to(bar, { y: barPos, opacity: 1, ...actionOption });
        html.classList.add("--scrolling");
    }

    //ドラッグorクリック時の共通処理
    const actionProcess = (e) => {
        rect = track.getBoundingClientRect();
        offsetY = e.clientY - rect.top;
        scrollRatio = offsetY / (vh - bar_H);
        scroll = scrollRatio * maxScroll;
        gsap.to(window, { scrollTo: scroll, ...actionOption });
    }

    const stayProcess = () => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            gsap.to(bar, { opacity: 0, ...actionOption });
            html.classList.remove("--scrolling");
        }, setTime);
    }

    //スクロール時の処理
    const scrollHandler = () => scrollProcess();

    //リサイズ時の処理
    const resizeHandler = () => {
        init();
        scrollProcess();
    }

    //スクロールバーのドラッグ
    const dragHandler = (e) => actionProcess(e);

    //スクロールバーのクリック
    const clickHandler = (e) => actionProcess(e);

    //初期設定
    init();
    scrollProcess();

    //スクロール時の処理を登録
    window.addEventListener("scroll", () => {
        scrollHandler();
        stayProcess();
    })

    //リサイズ時の処理を登録
    window.addEventListener("resize", () => {
        resizeHandler();
        stayProcess();
    })

    //スクロールバーのドラッグを登録
    // bar.addEventListener("mousedown", (e) => {
    //     e.preventDefault();
    //     dragHandler(e);
    //     window.addEventListener("mousemove", dragHandler);
    //     window.addEventListener("mouseup", () => {
    //         window.removeEventListener("mousemove", dragHandler);
    //     });
    // });

    //スクロールバーのクリックを登録
    // track.addEventListener("click", (e) => { clickHandler(e); });
}

export { setScrollBar }